import { registerLocaleData } from '@angular/common';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import localeBr from '@angular/common/locales/pt';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JoyrideModule } from 'ngx-joyride';
import { RedirectComponent } from '@shared/components/redirect/redirect.component';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SfCoreModule } from '@safra-frontend/core';
import { AlertaModule } from '@shared/modules/alerta/alerta.module';
import { AlertaService } from '@shared/modules/alerta/alerta.service';
import { HttpErrorInterceptor } from '@shared/services/http-error-interceptor.service';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions } from '@angular/material/core';
import { register } from 'swiper/element/bundle';
import { AutenticarService } from '@shared/services/autenticar.service';
import { TokenReducer } from '@shared/store/reducers/token.reducer';
import { StoreId } from '@shared/utils/interfaces/store.interface';

// register Swiper custom elements
register();

registerLocaleData(localeBr, 'pt');

const globalRippleConfig: RippleGlobalOptions = {
  disabled: true,
};

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export function initAppFactory(autenticar: AutenticarService) {
  return () => {
    const urlParams = new URLSearchParams(window.location.search);
    const rota = window.location.pathname;
    return autenticar.init(urlParams, rota);
  };
}

@NgModule({
  declarations: [AppComponent, RedirectComponent],
  imports: [
    AppRoutingModule,
    AlertaModule,
    BrowserAnimationsModule,
    MatProgressBarModule,
    SfCoreModule.forRoot(environment),
    StoreModule.forRoot({}, {}),
    StoreModule.forFeature(StoreId.TOKEN, TokenReducer),
    JoyrideModule.forRoot(),
    StoreDevtoolsModule.instrument({ maxAge: 25 }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory, // (http: HttpClient) => new TranslateHttpLoader(http, './assets/i18n/', '.json'),
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
      deps: [AlertaService],
    },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
    {
      provide: APP_INITIALIZER,
      useFactory: initAppFactory,
      deps: [AutenticarService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
